import planificationEscl from '../../../locales/es-CL/planification.json';
import planificationEsmx from '../../../locales/es-MX/planification.json';
import planificationEsco from '../../../locales/es-CO/planification.json';
import planificationEnus from '../../../locales/en-US/planification.json';
import moment from 'moment';
import axios from 'axios';
import Container from 'typedi';
import showAlert from '../../../alert/alertHandler';
import showConfirmation from '../../../confirmation/confirmationHandler';
import XLSX from 'xlsx';
import * as ExcelJS from 'exceljs';
import { v1 as uuidv1 } from 'uuid';
import { saveAs } from 'file-saver';
import RouteDetailMap from '../../../components/RouteDetailMap.vue';
import BuscadorDirecciones from '@/components/global/buscador-direcciones/buscador-direcciones.vue';
import showOperationDetail from '../operationDetailModal/operationDetailModalHandler';
import LogService from '../../../services/LogService';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';

export default {
  name: 'addOperation',
  props: ['planificationId', 'gapi', 'tags', 'itemNames', 'senderList', 'callback'],
  components: {
    BuscadorDirecciones,
    RouteDetailMap,
    VueCtkDateTimePicker,
  },
  i18n: {
    messages: {
      'es-CL': {
        planification: planificationEscl,
      },
      'es-MX': {
        planification: planificationEsmx,
      },
      'es-CO': {
        planification: planificationEsco,
      },
      'en-US': {
        planification: planificationEnus,
      },
    },
  },
  data() {
    return {
      logService: null,
      //Listados de datos a usar
      operations: [],
      distanceMatrixManual: {
        operations: [],
        origins: [],
        destinations: [],
      },
      spotsTemporalMassive: [],
      spotsTemporalData: [],
      isMainPageBussy: false,
      rowsExcelTranform: [],
      checkedOPerationsPending: [],
      checkedOPerationsIntegrations: [],
      pendingOperations: [],
      integrationsOperations: [],
      typeOperationOptions: [
        {
          type: 'DELIVERY',
          name: 'Entrega',
        },
        {
          type: 'COLLECTION',
          name: 'Retiro',
        },
      ],
      integrations: [],
      states: [
        /* {
          name: 'Todos',
          state: 'all',
        }, */
        {
          name: 'Pendientes',
          state: 'pending',
        },
        {
          name: 'No planificadas',
          state: 'unplanned',
        },
        {
          name: 'Rechazados',
          state: 'rejected',
        },
      ],
      rowsExcel: null,
      idOperationJob: 0,
      filterOpPending: null,
      filterOpIntegration: null,
      isFilterShownAddOps: false,
      isFilterClickedAddOps: false,
      isFilterAppliedAddOps: false,
      isMassiveBussy: false,
      isCancelled: false,
      selectedAllOperationsPending: false,
      selectedAllOperationsIntegration: false,
      showLoadOperationManual: true,
      showLoadOperationMassive: false,
      showLoadOperationPending: false,
      showLoadOperationIntegration: false,
      addOperationClicked: false,
      deletedTags: new Set(),
      totalOperationsPending: 0,
      totalOperationsIntegrations: 0,
      currentPageOperationPending: 1,
      currentPageOperationIntegration: 1,
      perPageOperationPending: 10,
      perPageOperationIntegration: 10,
      pageOptions: [10, 15, 20, 50, 100],
      excelHeaders: {
        nombre: 'Nombre operacion (Obligatorio)',
        tipoOperacion: 'Tipo de operación (Obligatorio)',
        direccion: 'Dirección  (Obligatorio)',
        ciudad: 'Ciudad  (Obligatorio)',
        estado: 'Estado  (Obligatorio)',
        pais: 'Pais  (Obligatorio)',
        neighborhood: this.$t('planification.planificationBuilder.operation.fieldNeighborhood'),
        extraDireccion: 'Dato extra dirección (Depto, Casa)',
        lat: 'Latitud',
        lon: 'Longitud',
        horarioInicial: 'Hora inicial (HH:mm)',
        horarioFinal: 'Hora final (HH:mm)',
        tiempoActividad: 'Tiempo de operacion (Por defecto: 10 min)',
        contacto: 'Persona de contacto',
        telefono: 'Teléfono de contacto',
        correo: 'Correo electrónico de contacto',
        volumen: 'Carga 1 (Volumen m3)',
        peso: 'Carga 2 (Peso kg)',
        dinero: 'Carga 3 (Dinero)',
        tag: 'Atributos',
        sender: 'Cliente',
        addinfo: 'Información adicional',
      },
      formOperationEditSpot: {
        addressComplement: null,
        neighborhood: null,
        name: null,
        address: null,
        lat: null,
        lon: null,
        idSpotTemporal: null,
        sender: null,
        documents: [],
      },
      formOperation: {
        addressComplement: null,
        neighborhood: null,
        name: null,
        address: null,
        lat: null,
        lon: null,
        idSpotTemporal: null,
        sender: null,
        documents: [],
        tags: null,
        volume: null,
        weight: null,
        money: null,
        startHour: null,
        endHour: null,
        spotServiceTime: null,
        contact: null,
        phone: null,
        email: null,
        additionalInfo: null,
      },
      formPendingOperation: {
        date: {
          start: moment(new Date().setDate(new Date().getDate() - 14)).format('YYYY-MM-DD'),
          end: moment(new Date()).format('YYYY-MM-DD'),
        },
        state: [
          {
            name: 'Pendientes',
            state: 'pending',
          },
          {
            name: 'No planificadas',
            state: 'unplanned',
          },
          {
            name: 'Rechazados',
            state: 'rejected',
          },
        ],
        integration: 'none',
      },
      formIntegrationOperation: {
        date: {
          start: null,
          end: null,
        },
        state: [
          {
            name: 'No planificadas',
            state: 'unplanned',
          },
        ],
        integrations: [],
      },
      maxCharacterLength: 3000,
    };
  },
  async created() {
    this.isMainPageBussy = true;
    this.dataAccess = this.$store.getters.dataAccess;
    this.logService = Container.get(LogService);
    this.integrations = await this.getIntegrationTypes();
    this.isMainPageBussy = false;
  },
  methods: {
    async getIntegrationTypes() {
      try {
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `getIntegrationTypes llamada a la api de lastmile`,
        });
        const response = await axios.get(`${this.$store.getters.urlAPI}/integration`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          let data = response.data.data;
          data = data.sort((a, b) => a.name.localeCompare(b.name));
          return data;
        }
        return [];
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `getIntegrationTypes fallo ${e.message}`,
        });
        console.log(e);
        return [];
      }
    },
    translateExcelPosition(fieldIndex, rowIndex) {
      let character;
      if (fieldIndex > 26) {
        const entero = Math.floor(fieldIndex / 26);
        let remnant = fieldIndex % 26;
        if (remnant === 0) remnant = 1;
        character = String.fromCharCode(96 + entero).toUpperCase() + String.fromCharCode(96 + remnant).toUpperCase();
      } else {
        character = String.fromCharCode(96 + fieldIndex).toUpperCase();
      }
      return character + rowIndex;
    },
    async prepareTagsExcel() {
      this.tagsExcel = '';

      let tagsEnabled = this.tags.filter((t) => t.enabled);
      for (let i = 0; i < tagsEnabled.length; i++) {
        if (i == tagsEnabled.length - 1) {
          this.tagsExcel += tagsEnabled[i].name;
        } else {
          this.tagsExcel += tagsEnabled[i].name + ',';
        }
      }
    },
    async prepareSenderExcel() {
      let senderListTemp = '';
      for (let i = 0; i < this.senderList.length; i++) {
        if (i == this.senderList.length - 1) {
          senderListTemp += this.senderList[i].name;
        } else {
          senderListTemp += this.senderList[i].name + ',';
        }
      }
      return senderListTemp;
    },
    async buildExcelPro() {
      await this.prepareTagsExcel();
      const wb = new ExcelJS.Workbook();
      const ws = wb.addWorksheet('Operaciones');

      const headers = [
        { header: this.excelHeaders.nombre, key: 'nac', width: 40 },
        { header: this.excelHeaders.tipoOperacion, key: 'top', width: 40 },
        { header: this.excelHeaders.direccion, key: 'dir', width: 40 },
        { header: this.excelHeaders.ciudad, key: 'ciu', width: 30 },
        { header: this.excelHeaders.estado, key: 'est', width: 30 },
        { header: this.excelHeaders.pais, key: 'ps', width: 20 },
        { header: this.excelHeaders.extraDireccion, key: 'ede', width: 40 },
        { header: this.excelHeaders.neighborhood, key: 'nbh', width: 40 },
        { header: this.excelHeaders.lat, key: 'lat', width: 20 },
        { header: this.excelHeaders.lon, key: 'lon', width: 20 },
        { header: this.excelHeaders.addinfo, key: 'addinfo', width: 40 },
        { header: this.excelHeaders.horarioInicial, key: 'hi', width: 20 },
        { header: this.excelHeaders.horarioFinal, key: 'hf', width: 20 },
        { header: this.excelHeaders.tiempoActividad, key: 'tda', width: 35 },
        { header: this.excelHeaders.contacto, key: 'pdc', width: 40 },
        { header: this.excelHeaders.telefono, key: 'tdc', width: 20 },
        { header: this.excelHeaders.correo, key: 'cec', width: 40 },
        { header: this.excelHeaders.volumen, key: 'c1', width: 30 },
        { header: this.excelHeaders.peso, key: 'c2', width: 30 },
        { header: this.excelHeaders.dinero, key: 'c3', width: 30 },
        { header: this.excelHeaders.tag, key: 'att', width: 25 },
        { header: this.excelHeaders.sender, key: 'cli', width: 25 },
      ];

      ws.columns = headers;

      ws.addRow({
        nac: '(Ejemplo)Actividad 1',
        top: 'Entrega',
        dir: 'SANTA MARIA 2670, PROVIDENCIA',
        ciu: 'Santiago',
        est: 'Región Metropolitana',
        ps: 'Chile',
        ede: 'Departamento 100',
        nbh: 'Colonia',
        lat: '-33.416552079248056',
        lon: '-70.60965343190408',
        c1: '10',
        c2: '50',
        c3: '10000',
        pdc: 'Paulina Muñoz',
        tdc: '965847147',
        cec: 'paulinamunoz@ejemplo.com',
        tda: 10,
        addinfo: '',
      });
      ws.addRow({
        nac: '(Ejemplo)Actividad 2',
        top: 'Entrega',
        dir: 'MARTIN DE ZAMORA 2964, LAS CONDES',
        ciu: 'Santiago',
        est: 'Región Metropolitana',
        ps: 'Chile',
        ede: 'Casa 1',
        nbh: 'Colonia',
        lat: '-33.42416668450864',
        lon: '-70.59221325889051',
        c1: '10',
        c2: '50',
        c3: '10000',
        pdc: 'David Rosales',
        tdc: '994345856',
        cec: 'davidrosales@ejemplo.com',
        tda: 10,
        addinfo: '',
      });
      ws.addRow({
        nac: '(Ejemplo)Actividad 3',
        top: 'Entrega',
        dir: 'Américo Vespucio 2680, Pudahuel',
        ciu: 'Santiago',
        est: 'Región Metropolitana',
        ps: 'Chile',
        ede: 'Porton de metal',
        nbh: 'Colonia',
        lat: '-33.38431880495116',
        lon: '-70.75814323190521',
        c1: '10',
        c2: '50',
        c3: '10000',
        pdc: 'Sergio Aguilera',
        tdc: '961483569',
        cec: 'sergioaguilera@ejemplo.com',
        tda: 10,
        addinfo: '',
      });
      ws.addRow({
        nac: '(Ejemplo)Actividad 4',
        top: 'Entrega',
        dir: 'PRESIDENTE RIESCO 5561, LAS CONDES',
        ciu: 'Santiago',
        est: 'Región Metropolitana',
        ps: 'Chile',
        ede: 'Oficina 50',
        nbh: 'Colonia',
        lat: '-33.40452067461955',
        lon: '-70.57419947608217',
        c1: '10',
        c2: '50',
        c3: '10000',
        pdc: 'Lucas Uribe',
        tdc: '977586912',
        cec: 'lucasuribe@ejemplo.com',
        tda: 10,
        addinfo: '',
      });
      ws.addRow({
        nac: '(Ejemplo)Actividad 5',
        top: 'Entrega',
        dir: 'ANDRES BELLO 2711, LAS CONDES',
        ciu: 'Santiago',
        est: 'Región Metropolitana',
        ps: 'Chile',
        ede: 'Departamento 11',
        nbh: 'Colonia',
        lat: '-33.41511908571772',
        lon: '-70.60501571656195',
        c1: '10',
        c2: '50',
        c3: '10000',
        pdc: 'Alonso Olate',
        tdc: '973625489',
        cec: 'alonsoolate@ejemplo.com',
        tda: 10,
        addinfo: '',
      });

      for (let i = 2; i < 200; i++) {
        ws.getCell(`B${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: ['"Entrega,Retiro"'],
        };
        ws.getCell(`F${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: ['"Chile,Mexico"'],
        };
        ws.getCell(`U${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`"${this.tagsExcel}"`],
        };
        ws.getCell(`V${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`"${await this.prepareSenderExcel()}"`],
        };
      }

      const buffer = await wb.xlsx.writeBuffer();
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const fileExtension = '.xlsx';
      const blob = new Blob([buffer], { type: fileType });
      saveAs(blob, 'Ejemplo carga masiva, excel lastmile' + fileExtension);
    },
    async receiveAddressInformation(addressInfo) {
      if (addressInfo.streetName !== '') {
        this.formOperation.addressComplement = addressInfo.addressComplement;
        this.formOperation.neighborhood = addressInfo.neighborhood;
        this.formOperation.addressExtra = addressInfo.city != undefined ? `${addressInfo.city}` : '';
        this.formOperation.addressExtra =
          (addressInfo.city != undefined || addressInfo.city == undefined) && addressInfo.state != undefined
            ? ` ${addressInfo.state}`
            : '';
        this.formOperation.address =
          addressInfo.number !== undefined
            ? `${addressInfo.streetName} ${addressInfo.number} ${this.formOperation.addressExtra}`
            : `${addressInfo.streetName} ${this.formOperation.addressExtra}`;
        this.formOperation.lat = addressInfo.coordinates.lat;
        this.formOperation.lon = addressInfo.coordinates.lng;
        this.formOperation.city = addressInfo.city;
        this.formOperation.state = addressInfo.state;
        this.formOperation.country = addressInfo.country;
        this.formOperation.streetNameSimple =
          addressInfo.number !== undefined ? `${addressInfo.streetName} ${addressInfo.number}` : addressInfo.streetName;

        const destinationPoint = {
          description: this.formOperation.address,
          typeName: this.$t('planification.planificationBuilder.operation.destination'),
          type: 'destination',
          coordinates: {
            lat: this.formOperation.lat,
            lng: this.formOperation.lon,
          },
        };
        this.showMapRoute(destinationPoint);
      }
    },
    async showMapRoute(point) {
      if (point != null) {
        try {
          console.log('Mostrando el gapi ', this.gapi);
          await this.$refs.map.setMultipleMarkersClean(this.gapi, point);
        } catch (e) {
          this.logService.sendError({
            component: 'operationProcess',
            message: `showMapRoute fallo el limpiado del mapa ${e.message}`,
          });
          console.log(e);
        }
      }
    },
    addfile(event) {
      try {
        this.isMassiveBussy = true;
        this.file = event.target.files[0];
        let fileReader = new FileReader();
        fileReader.readAsArrayBuffer(this.file);
        fileReader.onload = () => {
          this.arrayBuffer = fileReader.result;
          const data = new Uint8Array(this.arrayBuffer);
          const arr = new Array();
          for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
          const bstr = arr.join('');
          const workbook = XLSX.read(bstr, { type: 'binary', cellDates: true });
          const first_sheet_name = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[first_sheet_name];
          this.rowsExcel = XLSX.utils.sheet_to_json(worksheet, { raw: true });
          this.readFileExcel();
        };
      } catch {
        this.isMassiveBussy = false;
      }
    },
    async prepareFileExcel() {
      // Para comparar se quitan los espacios y todo en minuscula de
      // los headers con que se construyeron las plantillas
      const headCompare = {};
      Object.entries(this.excelHeaders).forEach(([key, value]) => {
        headCompare[key] = value.replaceAll(' ', '').toLowerCase();
      });

      const headerToFieldMap = {};
      Object.entries(headCompare).forEach(([originalKey, normalizedKey]) => {
        switch (originalKey) {
          case 'lat':
            headerToFieldMap[normalizedKey] = 'latitud';
            break;
          case 'lon':
            headerToFieldMap[normalizedKey] = 'longitud';
            break;
          default:
            headerToFieldMap[normalizedKey] = originalKey;
        }
      });
      for (let row of this.rowsExcel) {
        Object.entries(row).forEach((entry) => {
          let [key, value] = entry;
          // Header de la columna entrante pasa a minusculas sin espacios
          const keySource = key.trim().replaceAll(' ', '').toLowerCase();
          const targetField = headerToFieldMap[keySource];
          if (targetField) {
            row[targetField] = value;
          }
        });
      }
    },
    async loadMassSpotTemporal() {
      this.operationsMassive.forEach((element) => {
        let spotTemporal;
        spotTemporal = {
          addressComplement: element.addressComplement,
          neighborhood: element.neighborhood,
          address: element.address,
          city: element.city,
          state: element.state,
          country: element.country,
        };
        if (element.lat && element.lon) {
          const latSpot = parseFloat(element.lat);
          const lonSpot = parseFloat(element.lon);
          spotTemporal = {
            ...spotTemporal,
            lat: latSpot,
            lon: lonSpot,
          };
        }
        this.spotsTemporalMassive.push(spotTemporal);
      });
    },
    parseStringOrDate(dato) {
      // Verificar si es un string de 4 caracteres
      if (typeof dato === 'string' && dato.length === 4) {
        return dato.toString(); // Es un string de 4 caracteres
      }

      // Verificar si puede ser interpretado como una fecha válida
      if (!isNaN(Date.parse(dato))) {
        try {
          const dateSplit = dato.split(':');
          const hour = `${dateSplit[0][dateSplit[0].length - 2]}${dateSplit[0][dateSplit[0].length - 1]}`;
          const minutes = `${dateSplit[1][0]}${dateSplit[1][1]}`;
          let date = new Date(dato);
          if (hour !== date.getHours().toString()) {
            date.setHours(hour);
          }
          if (minutes !== date.getMinutes().toString()) {
            date.setMinutes(minutes);
          }
          return moment(date.getTime()).format('HH:mm').toString(); // Es una fecha válida
        } catch {
          return moment(new Date(dato).getTime()).format('HH:mm').toString(); // Es una fecha válida
        }
      }

      return null; // No es un string de 4 caracteres ni una fecha válida
    },
    async checkOperationsCountry(operationsDistinctCountry) {
      let countries = {};
      for (const excelRow of this.rowsExcelTranform) {
        if (excelRow.country && excelRow.country.trim() !== '') {
          countries[excelRow.country] = countries[excelRow.country] ? countries[excelRow.country] + 1 : 1;
        }
      }

      for (const operation of this.operations) {
        if (operation.country && operation.country.trim() !== '') {
          countries[operation.country] = countries[operation.country] ? countries[operation.country] + 1 : 1;
        }
      }

      if (Object.keys(countries).length === 0) return false;
      if (Object.keys(countries).length === 1) return true;

      // Encuentra el pais del que hay mas operaciones
      let selectedCountry = '';
      let max = -1;
      for (let country in countries) {
        if (countries[country] > max) {
          max = countries[country];
          selectedCountry = country;
        } else if (countries[country] === max) {
          return false;
        }
      }

      // Separar filas validas segun el pais
      let validRows = [];
      for (const excelRow of this.rowsExcelTranform) {
        if (excelRow.country.trim() === selectedCountry) {
          // Operaciones validas
          validRows.push(excelRow);
        } else {
          // Operaciones con paises distintos al de la mayoria
          operationsDistinctCountry.push(excelRow);
        }
      }

      // Reasignar el arreglo de filas de excel
      this.rowsExcelTranform = validRows;

      return true;
    },
    async confirmUploadExcel() {
      if (this.rowsExcelTranform.length < 1) {
        showAlert('Error', 'Debes seleccionar un archivo excel para cargar', 'error');
        return;
      }
      await this.processExcel();
    },
    getFileFromForm() {
      return this.rowsExcel;
    },
    getNameFomForm() {
      return this.formOperation.name;
    },
    getAddressFromForm() {
      return this.formOperation.address;
    },
    isEmailValid(email) {
      const re = /^[a-zA-Z0-9.ñ_%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return re.test(email.trim());
    },
    async addOperationManual() {
      this.addOperationClicked = true;
      if (this.formOperation.name && this.formOperation.address) {
        const deliveryDefault = {
          type: 'DELIVERY',
          name: 'Entrega',
        };
        this.addOperationClicked = false;
        let operation = {
          uuid: uuidv1(),
          idOperationJob: this.idOperationJob++,
          name: this.formOperation.name,
          typeOperation: this.formOperation.typeOperation ? this.formOperation.typeOperation : deliveryDefault,
          lat: this.formOperation.lat,
          lon: this.formOperation.lon,
          addressComplement: this.formOperation.addressComplement,
          neighborhood: this.formOperation.neighborhood,
          address: this.formOperation.streetNameSimple,
          city: this.formOperation.city,
          state: this.formOperation.state,
          country: this.formOperation.country,
          sender: this.formOperation.sender,
          documents: this.formOperation.documents,
          idSpotTemporal: null,
          tags: this.formOperation.tags,
          volume: this.formOperation.volume,
          weight: this.formOperation.weight,
          money: this.formOperation.money,
          startHour: this.formOperation.startHour,
          endHour: this.formOperation.endHour,
          spotServiceTime: this.formOperation.spotServiceTime ? this.formOperation.spotServiceTime : 10,
          contact: this.formOperation.contact,
          phone: this.formOperation.phone,
          email: this.formOperation.email,
          operationState: 'NOTHANDLED',
          resource: null,
          route: null,
          additionalInfo: this.formOperation.additionalInfo,
        };
        //TODO Se comenta este segmento hasta analizar el caso cuando hay operaciones en el mismo spot para la edición
        /*let operationSameSpot = this.operations.filter((operation) => operation.address == this.formOperation.address);
              if (operationSameSpot.length > 0) {
                operation.idSpotTemporal = operationSameSpot.idSpotTemporal;
                operation.nameSpot = operationSameSpot[0].nameSpot;
              } else {*/
        let spotTemporal = await this.saveSpotTemporal();
        operation.idSpotTemporal = this.formOperation.idSpotTemporal;
        operation.nameSpot = spotTemporal.name;
        operation.geocodingResult = spotTemporal.geocodingResult;
        if (this.planificationId) {
          this.distanceMatrixManual.operations.push(operation);
        }
        //}
        //operation.spotServiceTime = 10;
        this.operations.push(operation);
        this.rowsExcel = null;
        this.cleanFormOperation();
        if (typeof this.callback === 'function') {
          this.callback(this.operations, this.distanceMatrixManual, this.spotsTemporalData, 'manual');
        }
        await this.$refs.map.cleanMarkers();
      }
    },
    async saveSpotTemporal() {
      try {
        const body = {
          addressComplement: this.formOperation.addressComplement,
          neighborhood: this.formOperation.neighborhood,
          address: this.formOperation.streetNameSimple,
          city: this.formOperation.city,
          state: this.formOperation.state,
          country: this.formOperation.country.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
          lat: this.formOperation.lat,
          lon: this.formOperation.lon,
        };
        this.logService.sendInfo({
          component: 'operationProcess',
          message: `saveSpotTemporal enviando la data`,
          data: body,
        });
        const response = await axios.post(`${this.$store.getters.urlAPI}/spot/createTemporal`, body, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        let ret = response.data.data;
        this.formOperation.idSpotTemporal = ret.id;
        this.spotsTemporalData.push(ret);
        if (this.planificationId) {
          this.distanceMatrixManual.origins.push({
            name: ret.id,
            lat: ret.address.lat,
            lon: ret.address.lon,
          });
        }
        console.log('respuesta del servicio spot temporales', ret);
        return ret;
      } catch (e) {
        this.logService.sendError({
          component: 'operationProcess',
          message: `saveSpotTemporal fallo el servicio ${e.message}`,
        });
        this.isMainPageBussy = false;
        console.log(e);
        return null;
      }
    },
    cleanFormOperation() {
      this.formOperation.name = null;
      this.formOperation.address = null;
      this.formOperation.sender = null;
      this.formOperation.documents = null;
      this.formOperation.tags = null;
      this.formOperation.volume = null;
      this.formOperation.weight = null;
      this.formOperation.money = null;
      this.formOperation.startHour = null;
      this.formOperation.endHour = null;
      this.formOperation.spotServiceTime = null;
      this.formOperation.contact = null;
      this.formOperation.phone = null;
      this.formOperation.email = null;
    },
    async loadOperationMassive(operationExcel) {
      let operation = {
        uuid: uuidv1(),
        idOperationJob: this.idOperationJob++,
        name: operationExcel.name,
        address: operationExcel.address,
        city: operationExcel.city,
        state: operationExcel.state,
        country: operationExcel.country,
        addressComplement: operationExcel.addressComplement,
        neighborhood: operationExcel.neighborhood,
        typeOperation: this.typeOperationOptions.find(
          (operationType) =>
            operationType.name.toLowerCase().trim() == operationExcel.typeOperation.toLowerCase().trim(),
        ),
        lat: operationExcel.lat,
        lon: operationExcel.lon,
        startHour: this.parseStringOrDate(operationExcel.startHour),
        endHour: this.parseStringOrDate(operationExcel.endHour),
        spotServiceTime: operationExcel.operationTime ? operationExcel.operationTime : 10,
        contact: operationExcel.contact,
        phone: operationExcel.phone,
        email: operationExcel.email,
        volume: operationExcel.load1,
        weight: operationExcel.load2,
        money: operationExcel.load3,
        tags: operationExcel.tag,
        sender: operationExcel.sender,
        additionalInfo: operationExcel.additionalInfo,
        operationState: 'NOTHANDLED',
      };
      this.operationsMassive.push(operation);
      this.operations.push(operation);
      if (this.planificationId) {
        this.distanceMatrixManual.operations.push(operation);
      }
    },
    async saveMassSpotTemporalRequest() {
      let response = null;
      try {
        const body = this.spotsTemporalMassive;
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `saveMassSpotTemporal creando los spots temporales para las operaciones, esto va a la lambda`,
          data: body.length,
        });
        const ret = await axios.post(`${this.$store.getters.urlAPI}/api/massCreateTemporalSpot/request`, body, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
            'x-api-key': this.$store.getters.clientApiKey,
          },
        });
        response = ret.data;
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `saveMassSpotTemporal de lambda fallo ${e.message}`,
        });
        console.log(e);
      }

      const result = {
        status: null,
        message: null,
      };
      if (!response) {
        result.status = 'FAIL';
        result.message = 'noResponse';
        return result;
      }

      let statusResponse = await this.checkStatus(response.executionId);
      if (this.isCancelled) return { status: 'CANCELLED' };
      await new Promise((r) => setTimeout(r, 3000));
      if (this.isCancelled) return { status: 'CANCELLED' };
      let counter = 1;
      let failCounter = 0;

      // Primer ciclo: esperar a que esté listo
      while (statusResponse === 'notReady' && failCounter < 60) {
        statusResponse = await this.checkStatus(response.executionId);
        if (this.isCancelled) return { status: 'CANCELLED' };

        await new Promise((r) => setTimeout(r, 3000));
        if (this.isCancelled) return { status: 'CANCELLED' };

        failCounter++;
      }

      if (failCounter === 60) {
        throw new Error('Tiempo de espera excedido');
      }

      // Segundo ciclo: esperar a que esté DONE o FAIL
      while (statusResponse.data.phase !== 'DONE' && statusResponse.data.phase !== 'FAIL' && counter < 100) {
        console.log('Evaluando en cuanto esta el cancelado ', this.isCancelled);
        statusResponse = await this.checkStatus(response.executionId);
        if (this.isCancelled) return { status: 'CANCELLED' };

        counter++;
        await new Promise((r) => setTimeout(r, 3000));
        if (this.isCancelled) return { status: 'CANCELLED' };
      }

      if (counter >= 100) {
        return { status: 'FAIL', message: 'timeout' };
      }

      if (statusResponse.data.phase === 'DONE') {
        await this.addSpotTemporalMass(statusResponse.data.spotList);
        if (this.isCancelled) return { status: 'CANCELLED' };

        return { status: 'DONE' };
      } else {
        return { status: 'FAIL', message: statusResponse.message };
      }
    },
    async checkStatus(executionId) {
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        return await axios.get(
          `${this.$store.getters.urlAPI}/api/massCreateTemporalSpot/checkStatus/${executionId}`,
          config,
        );
      } catch (e) {
        return 'notReady';
      }
    },
    async saveMassSpotTemporal() {
      try {
        const body = this.spotsTemporalMassive;
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `saveMassSpotTemporal creando los spots temporales para las operaciones`,
          data: body,
        });
        const response = await axios.post(`${this.$store.getters.urlAPI}/spot/massCreateTemporal`, body, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        const ret = response.data.data;
        const result = {
          status: null,
        };
        if (response.data.status) {
          this.addSpotTemporalMass(ret);
          result.status = 'DONE';
          return result;
        } else {
          result.status = 'FAIL';
          return result;
        }
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `saveMassSpotTemporal fallo el servicio ${e.message}`,
        });
        console.log(e);
        return null;
      }
    },
    addSpotTemporalMass(response) {
      if (response.created) {
        for (let spot of response.created) {
          this.spotsTemporalData.push(spot);
        }
      } else {
        for (let spot of response) {
          this.spotsTemporalData.push(spot);
        }
      }
    },
    closeModal() {
      if (typeof this.callback === 'function') {
        this.callback([], [], [], 'closeModal');
      }
    },
    async processExcel() {
      this.isMassiveBussy = true;
      await this.$nextTick(); // le das tiempo al DOM a reflejar el estado ocupado
      this.spotsTemporalMassive = [];
      this.operationsMassive = [];
      let operationsInvalidSpot = [];
      let operationsDistinctCountry = [];

      let additionalInfoError = [];
      this.rowsExcelTranform.forEach((row, index) => {
        const addInfoLengthTemp = row.additionalInfo ? row.additionalInfo.length : 0;
        if (addInfoLengthTemp > this.maxCharacterLength) {
          console.log('index: ' + index + ' - ' + addInfoLengthTemp);
          additionalInfoError.push(index + 2);
        }
      });
      if (additionalInfoError.length > 0) {
        showAlert(
          this.$t('common.modals.errorTitulo'),
          'Las siguientes filas sobrepasan el límite de ' +
            this.maxCharacterLength +
            ' caracteres: [' +
            additionalInfoError +
            ']',
          'error',
        );
        this.isMassiveBussy = false;
        this.isMainPageBussy = false;
        this.closeExcel();
        return;
      }

      if (!(await this.checkOperationsCountry(operationsDistinctCountry))) {
        showAlert(
          this.$t('common.modals.errorTitulo'),
          this.$t('planification.planificationBuilder.operation.distinctCountriesError'),
          'error',
        );
        this.isMassiveBussy = false;
        this.isMainPageBussy = false;
        this.closeExcel();
        return;
      }
      let emailLength = [];
      let emailValid = [];
      this.rowsExcelTranform.forEach((row, index) => {
        if (!row.email) return;

        const listEmails = row.email.split(/[,;]/).map((e) => e.trim());
        row.email = listEmails.join(',');

        if (listEmails.length > 3) emailLength.push(index + 2);

        const allValid = listEmails.every(this.isEmailValid);
        if (!allValid) emailValid.push(index + 2);
      });
      const hasErrors = emailLength.length > 0 || emailValid.length > 0;
      if (emailLength.length) {
        showAlert(
          this.$t('common.modals.errorTitulo'),
          this.$t('planification.planificationBuilder.operation.limitEmails', { row: emailLength }),
          'error',
        );
      }
      if (emailValid.length) {
        showAlert(
          this.$t('common.modals.errorTitulo'),
          this.$t('planification.planificationBuilder.operation.invalidEmails', { row: emailValid }),
          'error',
        );
      }
      if (hasErrors) {
        this.isMassiveBussy = false;
        this.isMainPageBussy = false;
        this.closeExcel();
        return;
      }

      for (const row of this.rowsExcelTranform) {
        this.loadOperationMassive(row);
      }
      await this.loadMassSpotTemporal();

      let latError = [];
      let lonError = [];

      let latLonNotification = false;

      this.spotsTemporalMassive.forEach((spotTemporal, index) => {
        if (
          (spotTemporal.lat !== undefined && spotTemporal.lat !== null) ||
          (spotTemporal.lon !== undefined && spotTemporal.lon !== null)
        ) {
          latLonNotification = true;
        }
        //verifica formato de lat.
        if (typeof spotTemporal.lat == 'number' && !isNaN(spotTemporal.lat)) {
          if (Number.isInteger(spotTemporal.lat)) {
            latError.push(index + 2);
          }
        } else if (spotTemporal.lat !== undefined && spotTemporal.lat !== null) {
          latError.push(index + 2);
        }

        //verifica formato de lon.
        if (typeof spotTemporal.lon == 'number' && !isNaN(spotTemporal.lon)) {
          if (Number.isInteger(spotTemporal.lon)) {
            lonError.push(index + 2);
          }
        } else if (spotTemporal.lon !== undefined && spotTemporal.lon !== null) {
          lonError.push(index + 2);
        }
      });

      if (latLonNotification) {
        if (latError.length > 0 && lonError.length > 0) {
          showAlert(
            this.$t('common.modals.errorTitulo'),
            this.$t('planification.planificationBuilder.operation.latLonFormatError', {
              latErrorRow: latError,
              lonErrorRow: lonError,
            }),
            'error',
          );
        } else if (latError.length > 0) {
          showAlert(
            this.$t('common.modals.errorTitulo'),
            this.$t('planification.planificationBuilder.operation.latFormatError', { row: latError }),
            'error',
          );
        } else if (lonError.length > 0) {
          showAlert(
            this.$t('common.modals.errorTitulo'),
            this.$t('planification.planificationBuilder.operation.lonFormatError', { row: lonError }),
            'error',
          );
        }

        if (latError.length > 0 || lonError.length > 0) {
          this.isMassiveBussy = false;
          this.isMainPageBussy = false;
          this.closeExcel();
          return;
        }
      }

      let result;
      if (this.spotsTemporalMassive && this.spotsTemporalMassive.length > 100) {
        result = await this.saveMassSpotTemporalRequest();
      } else {
        result = await this.saveMassSpotTemporal();
      }

      if (!this.isCancelled) {
        await this.saveMassPointsTemporal(operationsInvalidSpot);
      }
      if (result.status === 'DONE') {
        if (typeof this.callback === 'function') {
          if (!this.isCancelled) {
            this.rowsExcel = null;
            this.cleanFormOperation();
            this.callback(this.operations, this.distanceMatrixManual, this.spotsTemporalData, 'massive');
          }
        }
        if (operationsInvalidSpot.length !== 0 || operationsDistinctCountry.length !== 0) {
          let title = this.$t('common.modals.exitoTitulo');
          let message = this.$t('planification.planificationBuilder.operation.modalSuccessMassive');
          let type = 'success';
          title = this.$t('planification.planificationBuilder.operation.modalWarningFinishedwErrors');
          message =
            this.$t('planification.planificationBuilder.operation.modalWarningErrorsDescription') +
            '. <strong>' +
            this.$t('planification.planificationBuilder.operation.modalWarningValidActivites') +
            '.</strong>';
          type = 'warning';

          message += '<br><br>';

          if (operationsInvalidSpot.length !== 0) {
            message +=
              this.$t('planification.planificationBuilder.operation.modalErrorMassiveSpotNull') +
              this.buildOperationListHtml(operationsInvalidSpot, 5);
          }

          if (operationsDistinctCountry.length !== 0) {
            message +=
              this.$t('planification.planificationBuilder.operation.modalErrorMassiveDistinctCountry') +
              this.buildOperationListHtml(operationsDistinctCountry, 5);
          }
          showAlert(title, message, type);
        }
      } else {
        if (!this.isCancelled) {
          showAlert(
            this.$t('common.modals.errorTitulo'),
            this.$t('planification.planificationBuilder.operation.modalErrorMassive') +
              (result.message != undefined ? ' [ERRORTYPE: ' + result.message + ']' : ''),
            'error',
          );
        }
      }
      this.isMassiveBussy = false;
      this.closeExcel();
    },
    activeFilter() {
      this.isFilterShownAddOps = !this.isFilterShownAddOps;
      this.isFilterClickedAddOps = !this.isFilterClickedAddOps;
    },
    activeUseFilter() {
      this.isFilterClickedAddOps = true;
    },
    toogleFilter() {
      if (this.isFilterShownAddOps && !this.isFilterClickedAddOps) {
        this.isFilterShownAddOps = false;
      }
      if (this.isFilterClickedAddOps) {
        this.isFilterClickedAddOps = false;
      }
    },
    buildOperationListHtml(listOperations, limit) {
      let message = '<ul>';
      for (let index = 0; index < listOperations.length; index++) {
        if (index + 1 > limit) break;
        const operation = listOperations[index];
        message += '<li>' + operation.name + '</li>';
      }

      if (listOperations.length > limit) {
        message +=
          '<li>' +
          this.$t('planification.planificationBuilder.operation.additionalOperations', {
            activities: listOperations.length - limit,
          }) +
          '</li>';
      }

      message += '</ul>';
      return message;
    },
    closeExcel() {
      this.showExcel = false;
      localStorage.setItem('openExcel', false);
    },
    async saveMassPointsTemporal(operationsInvalidSpot) {
      let validOperations = [];
      let usedSpotIds = new Set();
      for (let operation of this.operations) {
        let result = this.findDataLatLon(operation, usedSpotIds);
        if (result !== null) {
          operation.lat = result.address.lat;
          operation.lon = result.address.lon;
          operation.idSpotTemporal = result.id;
          operation.nameSpot = result.name;
          operation.geocodingResult = result.address.geocodingResult;
          validOperations.push(operation);
          if (this.planificationId) {
            this.distanceMatrixManual.origins.push({
              name: result.id,
              lat: result.address.lat,
              lon: result.address.lon,
            });
          }
        } else {
          operationsInvalidSpot.push(operation);
        }
      }
      this.operations = validOperations;
    },
    /**
     * Se encarga de retornar un spot que calce con las descripcion de la operacion para luego asignar lat y lon
     * @param {*} operation Operación a evaluar
     * @param {*} usedSpotIds Listado de spots ya utilizados para no reutilizarlos
     * @returns 
     */
    findDataLatLon(operation, usedSpotIds) {
      for (let element of this.spotsTemporalData) {
        if (
          element.address &&
          operation.address?.trim().toLowerCase() === element.address.street?.trim().toLowerCase() &&
          operation.city?.trim().toLowerCase() === element.address.city?.trim().toLowerCase() &&
          operation.state?.trim().toLowerCase() === element.address.state?.trim().toLowerCase() &&
          element.id &&
          !usedSpotIds.has(element.id)
        ) {
          usedSpotIds.add(element.id); // Marca este spot como usado
          return element;
        }
      }
      return null;
    },
    async readFileExcel() {
      this.rowsExcelTranform = [];
      this.prepareFileExcel();

      for (let row of this.rowsExcel) {
        if (await this.undefinedIfBlankAndTrim(row.nombre)) {
          let inTag = await this.undefinedIfBlankAndTrim(row.tag); // si es blanco lo deja undefined y le quita espacios
          let foundTag = await this.findTagObject(inTag); // null si no lo encuentra

          let inSenderTemp = await this.undefinedIfBlank(row.sender); // si es blanco lo deja undefined (no le quita espacios)
          let senderTemp = await this.findSenderObject(inSenderTemp);

          // Si el tag no se encontro en la lista de tags habilitados (foundTag = null)
          // y no era vacío (inTags !== undefined), entonces se deshabilito anteriormente
          if (inTag !== undefined && foundTag === null) this.deletedTags.add(inTag);

          let operation = {
            name: await this.undefinedIfBlankAndTrim(row.nombre),
            typeOperation: await this.undefinedIfBlankAndTrim(row.tipoOperacion),
            address: await this.undefinedIfBlankAndTrim(row.direccion),
            city: await this.undefinedIfBlankAndTrim(row.ciudad),
            state: await this.undefinedIfBlankAndTrim(row.estado),
            country: this.removeAccents(await this.undefinedIfBlankAndTrim(row.pais)),
            addressComplement: await this.undefinedIfBlankAndTrim(row.extraDireccion),
            neighborhood: await this.undefinedIfBlankAndTrim(row.neighborhood),
            lat: await this.undefinedIfNotNumber(row.latitud),
            lon: await this.undefinedIfNotNumber(row.longitud),
            startHour: await this.undefinedIfBlankAndTrim(row.horarioInicial),
            endHour: await this.undefinedIfBlankAndTrim(row.horarioFinal),
            operationTime: await this.undefinedIfNotNumber(row.tiempoActividad),
            contact: await this.undefinedIfBlankAndTrim(row.contacto),
            phone: await this.undefinedIfBlankAndTrim(row.telefono),
            email: await this.undefinedIfBlankAndTrim(row.correo),
            load1: await this.undefinedIfNotNumber(row.volumen),
            load2: await this.undefinedIfNotNumber(row.peso),
            load3: await this.undefinedIfNotNumber(row.dinero),
            tag: foundTag ? foundTag : undefined,
            sender: senderTemp ? senderTemp : undefined,
            additionalInfo: row.addinfo ? String(row.addinfo) : undefined,
          };
          this.rowsExcelTranform.push(operation);
        }
      }
      console.log('EXCEL PREPROCESADO', this.rowsExcelTranform);
      this.isMassiveBussy = false;
      this.checkTagsChange();
    },
    removeAccents(str) {
      if (str != null && str != undefined) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      }
      return str;
    },
    async undefinedIfBlankAndTrim(val) {
      if (val == undefined || val == null) return undefined;
      let value = String(val);
      return value.trim() !== '' ? value.trim() : undefined;
    },
    async undefinedIfBlank(val) {
      if (val == undefined || val == null) return undefined;
      let value = String(val);
      return value.trim() !== '' ? value : undefined;
    },
    async undefinedIfNotNumber(value) {
      if (typeof value === 'number') return value;
      if (value == undefined || value == null) return undefined;
      try {
        let number = Number(value.trim());
        if (isNaN(number)) return undefined;
        return number;
      } catch (e) {
        console.log("cannot transform value '" + value + "' into number");
      }
      return undefined;
    },
    checkTagsChange() {
      // Muestra los tags que han sido desactivads o ya no estan disponibles
      let deletedTagsList = Array.from(this.deletedTags);
      if (deletedTagsList.length > 0) {
        let notValidTags = deletedTagsList.sort().join(', ') + '.';
        showAlert(
          this.$t('common.modals.warning'),
          this.$t('planification.planificationBuilder.unavailableTags') + notValidTags,
          'error',
        );
        this.deletedTags = new Set();
      }
    },
    async findTagObject(name) {
      for (let tag of this.tags.filter((t) => t.enabled)) {
        if (tag.name == name) {
          return tag;
        }
      }
      return null;
    },
    async findSenderObject(senderName) {
      for (let sender of this.senderList) {
        if (senderName == sender.name) {
          return sender;
        }
      }
      return null;
    },
    async loadOperation() {
      this.isMainPageBussy = true;
      if (this.showLoadOperationManual) {
        await this.addOperationManual();
      } else if (this.showLoadOperationMassive) {
        await this.confirmUploadExcel();
      } else if (this.showLoadOperationPending) {
        await this.addOperations(this.checkedOPerationsPending, this.unCheckAllOperationPending);
      } else if (this.showLoadOperationIntegration) {
        await this.addOperations(this.checkedOPerationsIntegrations, this.unCheckAllOperationIntegration);
      }
      this.isMainPageBussy = false;
    },
    async addOperations(checkedOperations, uncheckcallback) {
      const actualDateZone = moment(new Date().getTime()).format('YYYY-MM-DD') + ' 00:00:00';
      const newOperations = checkedOperations.filter(
        (operation) => !this.operations.some((o) => o.uuid === operation.uuid),
      );
      if (newOperations.length === 0) {
        uncheckcallback();
        return;
      }
      newOperations.forEach(async (operation) => {
        console.log(operation);
        const tags = operation.tags ? this.tags.filter((tag) => operation.tags.includes(tag.id.toString())) : null;
        let body = {
          idOperationJob: this.idOperationJob++,
          uuid: operation.uuid,
          idSpotTemporal: operation.spot.id,
          name: operation.name,
          tags: tags,
          addressComplement: operation.spot.address.addressComplement,
          neighborhood: operation.spot.address.neighborhood,
          address: operation.spot.address.street,
          city: operation.spot.address.city,
          state: operation.spot.address.state,
          country: operation.spot.address.country.name,
          typeOperation: this.typeOperationOptions.find((operationType) => operationType.type == operation.type),
          lat: operation.spot.address.lat,
          lon: operation.spot.address.lon,
          startHour:
            operation.relation && operation.relation.spotStartTime
              ? this.obtainHour(actualDateZone, operation.relation.spotStartTime)
              : null,
          endHour:
            operation.relation && operation.relation.spotEndTime
              ? this.obtainHour(actualDateZone, operation.relation.spotEndTime)
              : null,
          spotServiceTime: operation.spotTimeService ? operation.spotTimeService / 60 : 10,
          contact: operation.customerName ?? null,
          phone: operation.customerPhone ?? null,
          email: operation.customerEmail ?? null,
          additionalInfo: operation.additionalInfo ?? null,
          idSender: operation.sender?.id ?? null,
          sender: operation.sender,
          documents: operation.documents ?? [],
          volume: operation.volume,
          weight: operation.weight,
          money: operation.money,
          operationState: 'NOTHANDLED',
          resource: null,
          route: null,
        };
        const bodySpot = {
          id: operation.spot.id,
          address: {
            id: operation.spot.address.id,
            addressComplement: operation.spot.address.addressComplement,
            neighborhood: operation.spot.address.neighborhood,
            street: operation.spot.address.street,
            city: operation.spot.address.city,
            state: operation.spot.address.state,
            country: {
              name: operation.spot.address.country?.name ?? 'Empty',
            },
            lat: operation.spot.address.lat,
            lon: operation.spot.address.lon,
          },
        };
        if (this.planificationId) {
          this.distanceMatrixManual.operations.push(body);
          this.distanceMatrixManual.origins.push({
            name: operation.spot.id,
            lat: operation.spot.address.lat,
            lon: operation.spot.address.lon,
          });
        }
        this.spotsTemporalData.push(bodySpot);
        this.operations.push(body);
      });
      showAlert(
        this.$t('common.modals.exitoTitulo'),
        this.$t('planification.planificationBuilder.operation.modalSuccess'),
        'success',
      );
      if (typeof this.callback === 'function') {
        this.callback(this.operations, this.distanceMatrixManual, this.spotsTemporalData, 'fromBd');
      }
      uncheckcallback();
    },
    transformState(relation) {
      if (!relation) {
        relation = {
          idState: 'UNPLANNED',
        };
      }
      return this.$t(`planification.planificationBuilder.state['${relation.idState}']`);
    },
    async preEditOperation() {
      if (this.formOperation.name && this.formOperation.address) {
        //Si quiero pree editar una operacion, puede ser cuando creo la planificacion o entro a añadir mas operaciones en una planificacion ya creada
        const bodyData = {
          gapi: this.gapi,
          planificationId: this.planificationId,
          tags: this.tags,
          senderList: this.senderList,
          itemNames: this.itemNames,
          mode: this.planificationId ? 'fromModal' : 'preLoad',
        };
        if (typeof this.formOperation.typeOperation === 'string') {
          this.formOperation.typeOperation = this.typeOperationOptions.find(
            (operationType) => operationType.type == this.formOperation.typeOperation,
          );
        } else {
          this.formOperation.typeOperation = {
            type: 'DELIVERY',
            name: 'Entrega',
          };
        }
        this.formOperation.additionalInfo = null;
        showOperationDetail(
          bodyData,
          this.formOperation,
          this.operations,
          this.spotsTemporalData,
          this.distanceMatrixManual,
          async (updateOperation, mode) => {
            if (mode == 'update') {
              this.formOperation = updateOperation;
              await this.loadOperation();
            } else {
              this.closeModal();
            }
          },
        );
      } else {
        showAlert(
          this.$t('common.modals.errorTitulo'),
          this.$t('planification.planificationBuilder.validaciones.emptyNameAdress'),
          'error',
        );
      }
    },
    loadOperationManual() {
      this.showLoadOperationMassive = false;
      this.showLoadOperationPending = false;
      this.showLoadOperationManual = true;
      this.showLoadOperationIntegration = false;
    },
    showOperationMassive() {
      this.showLoadOperationManual = false;
      this.showLoadOperationPending = false;
      this.showLoadOperationMassive = true;
      this.showLoadOperationIntegration = false;
    },
    showOperationPending() {
      this.cleanEmptyFiltersText();
      this.showLoadOperationManual = false;
      this.showLoadOperationMassive = false;
      this.showLoadOperationPending = true;
      this.showLoadOperationIntegration = false;
      this.toogleFilter();
      this.requestOps();
    },
    showOperationIntegration() {
      this.cleanEmptyFiltersText();
      //Si solo hay una integración existente, entonces selecciono automaticamente la primera
      if (
        this.integrations.length == 1 &&
        this.formIntegrationOperation.integrations.length == 0 &&
        this.integrations.length > 0
      ) {
        this.formIntegrationOperation.integrations.push(this.integrations[0]);
      }
      if (this.formIntegrationOperation.integrations.length != 0) {
        this.isFilterAppliedAddOps = true;
      }
      if (
        this.formIntegrationOperation.date &&
        this.formIntegrationOperation.date.start == null &&
        this.formIntegrationOperation.date.end == null
      ) {
        let endDate = new Date();
        endDate = endDate.setDate(endDate.getDate() - 14);
        this.formIntegrationOperation.date.start = moment(endDate).format('YYYY-MM-DD');
        this.formIntegrationOperation.date.end = moment(new Date()).format('YYYY-MM-DD');
      }
      this.showLoadOperationManual = false;
      this.showLoadOperationMassive = false;
      this.showLoadOperationPending = false;
      this.showLoadOperationIntegration = true;
      this.toogleFilter();
      this.requestOpsIntegration();
    },
    cleanEmptyFiltersText() {
      this.emptyState = false;
      this.emptySearchDate = false;
      this.emptyIntegration = false;
    },
    async requestOpsIntegration() {
      this.isSearchBussy = true;
      this.selectedAllOperationsIntegration = false;
      if (
        this.formIntegrationOperation.date == null ||
        (this.formIntegrationOperation.date &&
          this.formIntegrationOperation.date.start == null &&
          this.formIntegrationOperation.date.end == null)
      ) {
        let startDate = new Date();
        startDate = startDate.setDate(startDate.getDate() - 14);
        this.formIntegrationOperation.date = {
          start: moment(startDate).format('YYYY-MM-DD'),
          end: moment(new Date()).format('YYYY-MM-DD'),
        };
      }
      if (this.formIntegrationOperation.integrations.length === 0) {
        this.formIntegrationOperation.integrations = this.integrations;
      }
      if (
        (this.formIntegrationOperation.date && this.formIntegrationOperation.date.start) ||
        this.formIntegrationOperation.integrations.length > 0
      ) {
        this.isFilterAppliedAddOps = true;
      } else {
        this.isFilterAppliedAddOps = false;
      }
      this.checkedOPerationsIntegrations = [];
      const page = -1; //El -1 es para que el servicio no use paginador al momento de traer la data
      const pageSize = this.perPageOperationIntegration;
      const filters = this.formIntegrationOperation;
      const data = await this.searchOperations(page, pageSize, filters, this.integrationsOperations, true);
      this.integrationsOperations = data.data;
      this.totalOperationsIntegrations = data.paginator ? data.paginator.totalRows : 0;
      this.isSearchBussy = false;
    },
    async handlePageChange() {
      this.isSearchBussy = true;
      this.selectedAllOperationsPending = false;
      const page = this.currentPageOperationPending;
      const pageSize = this.perPageOperationPending;
      const filters = this.formPendingOperation;
      const data = await this.searchOperations(page, pageSize, filters, this.pendingOperations, false);
      this.pendingOperations = data.data;
      this.totalOperationsPending = data.paginator ? data.paginator.totalRows : 0;
      this.isSearchBussy = false;
    },
    async requestOps() {
      this.isSearchBussy = true;
      this.selectedAllOperationsPending = false;
      if (
        this.formPendingOperation.date == null ||
        (this.formPendingOperation.date &&
          this.formPendingOperation.date.start == null &&
          this.formPendingOperation.date.end == null)
      ) {
        let startDate = new Date();
        startDate = startDate.setDate(startDate.getDate() - 14);
        this.formPendingOperation.date = {
          start: moment(startDate).format('YYYY-MM-DD'),
          end: moment(new Date()).format('YYYY-MM-DD'),
        };
      }
      if (this.formPendingOperation.state.length === 0) {
        this.formPendingOperation.state = this.states;
      }
      if (
        (this.formPendingOperation.date && this.formPendingOperation.date.start) ||
        this.formPendingOperation.state.length > 0
      ) {
        this.isFilterAppliedAddOps = true;
      } else {
        this.isFilterAppliedAddOps = false;
      }
      this.checkedOPerationsPending = [];
      const page = this.currentPageOperationPending;
      const pageSize = this.perPageOperationPending;
      const filters = this.formPendingOperation;
      const data = await this.searchOperations(page, pageSize, filters, this.pendingOperations, false);
      this.pendingOperations = data.data;
      this.totalOperationsPending = data.paginator ? data.paginator.totalRows : 0;
      this.isSearchBussy = false;
    },
    limitText(count) {
      return `${this.$t('planification.search.limitText')} ${count}`;
    },
    async searchOperations(page, pageSize, formOperationFilter, globalList, isIntegration) {
      if (!this.validSearch(formOperationFilter)) {
        return { data: globalList, paginator: globalList.length };
      }

      const formatDate = (date, time) => new Date(`${moment(date).format('YYYY-MM-DD')} ${time}`).getTime();

      const today = new Date();
      const startDate = formOperationFilter.date?.start
        ? formatDate(formOperationFilter.date.start, '00:00:00')
        : formatDate(today, '00:00:00');

      const endDate = formOperationFilter.date?.end
        ? formatDate(formOperationFilter.date.end, '23:59:59')
        : formatDate(moment().subtract(14, 'days'), '23:59:59');

      const queryParams = [
        `pageNum=${page}`,
        `pageSize=${pageSize}`,
        ...formOperationFilter.state.map((s) => `state=${s.state}`),
        ...(isIntegration && formOperationFilter.integrations?.length
          ? formOperationFilter.integrations.map((i) => `integrations=${i.id}`)
          : []),
        `createdFromDate=${startDate}`,
        `createdToDate=${endDate}`,
      ];
      const url = `${this.$store.getters.urlAPI}/operation?${queryParams.join('&')}`;
      this.logService.sendInfo({
        component: 'planificationBUilder',
        message: `searchOperations va a buscar las operaciones con el siguiente path a la api ${url}`,
      });
      try {
        const { data } = await axios.get(url, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (data.status) {
          //El map se usa para que no se deba hacer un find por cada operación que traera el servicio
          let integrationsUsed = new Map();
          data.data.forEach((op) => {
            const type = op.integrationType;
            if (type) {
              if (integrationsUsed.has(type)) {
                op.integration = integrationsUsed.get(type);
              } else {
                const infoIntegration = this.integrations.find((integration) => integration.id == type);
                if (infoIntegration) {
                  integrationsUsed.set(type, infoIntegration.name);
                  op.integration = infoIntegration.name;
                }
              }
            }
          });
          if (isIntegration) {
            data.data = data.data.sort((a, b) => this.sortRulesOps(a, b));
          }
        }
        return data;
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `searchOperations fallo el llamado para obtener operaciones ${e.message}`,
        });
        if (e.response.data.message == 'No encontrado') {
          return { data: [], paginator: 0 };
        }
        console.log(e.response.data);
      }
    },

    validSearch(formOperationFilter) {
      let validDate = this.validateLimitDays(formOperationFilter);
      let validState = this.validateState(formOperationFilter);
      return validDate && validState;
    },
    validateState(formOperationFilter) {
      if (formOperationFilter.state.length > 0) {
        this.emptyState = false;
        return true;
      }
      this.emptyState = true;
      return false;
    },
    validateLimitDays(formOperationFilter) {
      if (formOperationFilter.date && formOperationFilter.date.start && formOperationFilter.date.end) {
        let validDate = false;
        let fecha1 = new Date(formOperationFilter.date.start);
        let fecha2 = new Date(formOperationFilter.date.end);
        let differenceDays = Math.abs(fecha2 - fecha1) / (1000 * 60 * 60 * 24);

        if (differenceDays > 31) {
          this.validDate = false;
        } else {
          this.validDate = true;
          validDate = true;
        }
        return validDate;
      } else {
        this.validDate = true;
        return true;
      }
    },
    transformDate(date) {
      if (date) {
        return moment(new Date(date)).format('DD-MM-YYYY');
      } else {
        return '-';
      }
    },
    deleteIntegrationOperation(operation) {
      showConfirmation(
        this.$t('planification.planificationBuilder.modal.confirm'),
        this.$t('planification.planificationBuilder.modal.bodyDelete', { name: operation.name }),
        async () => {
          await this.deleteOperationFromDb(operation.id);
        },
        this.$t('common.cruds.aceptar'),
        this.$t('common.cruds.cerrar'),
      );
    },
    async deleteOperationFromDb(id) {
      try {
        this.isSearchBussy = true;
        this.logService.sendInfo({
          component: 'operationProcess',
          message: `deleteOperationFromDb vamos a intentar eliminar la operación ${id}`,
        });
        const url = `${this.$store.getters.urlAPI}/operation/massDelete`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.post(url, [id], config);
        if (response.data.status) {
          this.selectedAllOperationsIntegration = false;
          this.checkedOPerationsIntegrations = [];
          const page = this.currentPageOperationIntegration;
          const pageSize = this.perPageOperationIntegration;
          const filters = this.formIntegrationOperation;
          const data = await this.searchOperations(page, pageSize, filters, this.integrationsOperations, true);
          this.integrationsOperations = data.data;
          this.totalOperationsIntegrations = data.paginator ? data.paginator.totalRows : 0;
          this.isSearchBussy = false;
        } else {
          this.isSearchBussy = false;
          showAlert('Error', this.$t('planification.planificationBuilder.modal.failedDeleteOperation'));
        }
      } catch (e) {
        this.logService.sendError({
          component: 'operationProcess',
          message: `deleteOperationFromDb fallo eliminar la operación ${e.message}`,
        });
        showAlert('Error', this.$t('planification.planificationBuilder.modal.failedDeleteOperation'));
        this.isSearchBussy = false;
        return false;
      }
    },
    transformSpot(spot) {
      return spot.address.street + ', ' + spot.address.city + ', ' + spot.address.state;
    },
    sortRulesOps(a, b) {
      // 1. Ordenar por fecha (ascendente)
      if (b.createdAt !== a.createdAt) {
        return b.createdAt > a.createdAt ? 1 : -1;
      }
      const nameCompare = a.name.localeCompare(b.name);
      if (nameCompare !== 0) return nameCompare;
      const integrationCompare = a.integration.localeCompare(b.integration);
      if (integrationCompare !== 0) return integrationCompare;
      const spotCompare = this.transformSpot(a.spot).localeCompare(this.transformSpot(b.spot));
      if (spotCompare !== 0) return spotCompare;
    },
    unCheckAllOperationPending() {
      this.checkedOPerationsPending = [];
    },
    unCheckAllOperationIntegration() {
      this.selectedAllOperationsIntegration = false;
      this.checkedOPerationsIntegrations = [];
    },
    unCheckAllOperationPendingPerPage() {
      this.checkedOPerationsPending = this.checkedOPerationsPending.slice(
        (this.currentPageOperationPending - 1) * this.perPageOperationPending,
        this.currentPageOperationPending * this.perPageOperationPending,
      );
    },
    checkOperationPending: function () {
      if (this.selectedAllOperationsPending) {
        this.checkAllOperation(this.pendingOperations, this.checkedOPerationsPending);
      } else {
        this.unCheckAllOperationPending(this.checkedOPerationsPending);
      }
    },
    checkOperationIntegration: function () {
      if (this.selectedAllOperationsIntegration) {
        this.checkAllOperation(this.filterOpIntegratioFirstView, this.checkedOPerationsIntegrations);
      } else {
        this.unCheckAllOperationIntegration(this.checkedOPerationsIntegrations);
      }
    },
    checkAllOperation(operationList, checkedOperations) {
      for (let operation of operationList) {
        //Selecciono solamente vehículos que no estan siendo utilizados
        if (!checkedOperations.find((checkOp) => checkOp.id === operation.id)) {
          checkedOperations.push(operation);
        }
      }
    },
  },
  computed: {
    emptyOperationName() {
      return (this.formOperation.name === null || this.formOperation.name === '') && this.addOperationClicked;
    },
    emptyOperationAddress() {
      return (this.formOperation.address === null || this.formOperation.address === '') && this.addOperationClicked;
    },
    filterOpPendingFirstView() {
      if (this.filterOpPending) {
        return this.pendingOperations.filter((op) =>
          op.name.toUpperCase().includes(this.filterOpPending.toUpperCase()),
        );
      }
      return this.pendingOperations;
    },
    filterOpIntegratioFirstView() {
      if (this.filterOpIntegration) {
        return this.integrationsOperations.filter((op) =>
          op.name.toUpperCase().includes(this.filterOpIntegration.toUpperCase()),
        );
      }
      return this.integrationsOperations;
    },
    shortCuts() {
      return [
        { key: 'thisWeek', label: this.$t(`planification.planificationBuilder.shortcuts.thisWeek`), value: 'isoWeek' },
        { key: 'lastWeek', label: this.$t(`planification.planificationBuilder.shortcuts.lastWeek`), value: '-isoWeek' },
        { key: 'last7Days', label: this.$t(`planification.planificationBuilder.shortcuts.last7Days`), value: 7 },
        { key: 'last14Days', label: this.$t(`planification.planificationBuilder.shortcuts.last14Days`), value: 14 },
        { key: 'last30Days', label: this.$t(`planification.planificationBuilder.shortcuts.last30Days`), value: 30 },
        { key: 'thisMonth', label: this.$t(`planification.planificationBuilder.shortcuts.thisMonth`), value: 'month' },
      ];
    },
    operationPendingField() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'select',
          label: '',
          ...common,
        },
        {
          key: 'name',
          label: this.$t('planification.planificationBuilder.table.name'),
          ...common,
        },
        {
          key: 'spot',
          label: this.$t('planification.planificationBuilder.table.spot'),
          ...common,
        },
        {
          key: 'relation',
          label: this.$t('planification.planificationBuilder.table.state'),
          ...common,
        },
        {
          key: 'motive',
          label: this.$t('planification.planificationBuilder.table.motive'),
          ...common,
        },
        {
          key: 'subMotive',
          label: this.$t('planification.planificationBuilder.table.submotive'),
          ...common,
        },
      ];
    },
    operationIntegrationField() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'select',
          label: '',
          ...common,
        },
        {
          key: 'name',
          label: this.$t('planification.planificationBuilder.table.name'),
          ...common,
        },
        {
          key: 'integration',
          label: this.$t('planification.planificationBuilder.table.integration'),
          ...common,
        },
        {
          key: 'spot',
          label: this.$t('planification.planificationBuilder.table.spot'),
          ...common,
        },
        {
          key: 'createdAt',
          label: this.$t('planification.planificationBuilder.table.date'),
          ...common,
        },
        {
          key: 'action',
          label: this.$t('planification.planificationBuilder.table.actions'),
          ...common,
        },
      ];
    },
  },
  mounted() {
    this.$on('cancelado-changed', (val) => {
      this.isCancelled = val;
    });
  },
};
